<template>
  <div :key="refreshKey" class="sidebar">
    <div class="my-3 pa-3 d-flex">
      <memberAvatar :avatar="avatar" />
      <div class="ml-3">
        <h3 class="text-lg word-break--break-all">{{ tokenName }}</h3>
        <h4 class="text-sm word-break--break-all">{{ email }}</h4>
      </div>
    </div>
    <v-select
      v-if="isLogin && tokenRole === 'store'"
      dense
      label="切換供應商"
      class="px-4"
      outlined
      @change="changeProvider"
      :loading="loadingCooperateProvider"
      :items="cooperateProviders"
      item-text="name"
      item-value="providerId"
      v-model="focusProvider"
    ></v-select>

    <v-list dense v-if="true" nav>
      <v-list-item v-if="isLogin" dense @click="$helper.account.logout()">
        <v-list-item-content>
          <v-list-item-title class="pb-3">歡迎回來，{{ layoutProviderName }}</v-list-item-title>
          <v-list-item-title>登出</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-else dense @click="lineLogin">
        <v-list-item-content>
          <v-list-item-title>登入</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <component v-for="(node, index) in getMenuData()" :is="getComponent(node)" :key="index" :node="node" :index="index">
      </component>
    </v-list>
    <div class="pa-3 terms-wrap" v-if="$route.path.match(/provider-store/)">
      <router-link :to="{ name: 'service-terms' }">
        <span>服務條款</span>
      </router-link>
      和
      <router-link :to="{ name: 'privacy-terms' }">
        <span>隱私權條款</span>
      </router-link>
    </div>
  </div>
</template>

<script lang="babel" type="text/babel">
import {mapGetters} from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
    }
  },
  data: () => ({
    focusProvider: null,
    loadingCooperateProvider: false,
    cooperateProviders: [],
  }),
  mounted() {
    this.focusProvider = this.layoutProviderId
    this.$root.$on(`uploadCooperateProvider`, this.loadCooperateProvider)
    this.loadCooperateProvider()
  },
  methods: {
    async loadCooperateProvider() {
      if (this.tokenRole != 'store') {
        return
      }
      this.loadingCooperateProvider = true
      let result = []
      try {
        result = await this.$api.collection.storeApi.coProviderIndex(this.storeId(), {
          pager: 0,
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingCooperateProvider = false
      }
      this.cooperateProviders = result
    },
    async changeProvider() {
      const query = this.$route.query
      if (query.filter) {
        delete query.filter
      }
      const route = {
        name: 'store-product-list',
        params: {
          ...this.$route.params,
          providerId: this.focusProvider,
        },
        query: query,
      }
      this.$router.push(route)
      await this.$helper.delay(0.2)
      window.location.reload()
    },
    reload() {
      window.location.reload()
    },
    getMenuData() {
      const menu = this.getMenuByRole() || []
      return this.$helper.getComputedLinkList(menu)
    },
    storeId() {
      return this.$store.getters[`member/storeId`]
    },
    checkMenu(arr) {
      const vm = this
      const currMemberRole = vm.currMemberRole
      const checkedMenu = []
      let curr
      let group
      for (const i in arr) {
        curr = arr[i]
        let checked = false

        if (Object.prototype.hasOwnProperty.call(curr, 'group')) {

          curr.group = curr.group.filter(item => item.allowedRoles.length != 0 && item.allowedRoles.some(name => currMemberRole.roles.includes(name)))
          if (curr.group.length != 0) {
            checked = true
          }
        } else if (Object.prototype.hasOwnProperty.call(curr, 'allowedRoles') && (curr.allowedRoles.length != 0 && curr.allowedRoles.some(name => currMemberRole.roles.includes(name)))) {
          checked = true
        }

        checked && checkedMenu.push(curr)
      }
      return checkedMenu
    },
    getMenuByRole() {
      const tokenRole = this.tokenRole
      if (!tokenRole || !this.currMemberRole) {
        return []
      }
      
      if(tokenRole == this.$tokenRoleConstant.ROLE_PROVIDER && this.providerStatus != this.$providerApplyStatus.STATUS_APPLY) {
        return window.eagleLodash.cloneDeep(window.bootstrap.getMenu('unauthProvider'))
      }
      
      if (tokenRole != 'store' || (tokenRole == 'store' && this.hasStore)) {
        const menu = window.eagleLodash.cloneDeep(window.bootstrap.getMenu(tokenRole))
        
        // 非 主要管理者/共同管理員 要過濾選單
        const currMemberRole = this.currMemberRole
        if (!currMemberRole._isManager) {
          return this.checkMenu(menu)
        }

        return menu
      }
      
      // 都沒有tokenRole, 代表沒註冊過, 用路由判斷menu
      if(this.$route.path.match(/provider-store/)) {
        return window.eagleLodash.cloneDeep(window.bootstrap.getMenu('unauthStore'))
      }
      return window.eagleLodash.cloneDeep(window.bootstrap.getMenu('unauthProvider'))
    },
    getComponent(node) {
      if(Array.isArray(node.group)) return 'menuGroup'
      return 'menuLink'
    },
    lineLogin() {
      if (this.$helper.whereLayout() == "provider-store") {
        this.$root.gaLogEvent('商店_點擊_登入')
        if(!this.layoutProvider.line_login_channel_id) {
          console.warn(`供應商channel id未設定`, this.layoutProvider.line_login_channel_id)
        }
        const host = `${window.location.origin}`
        const href = this.$router.resolve({
          name: 'store-line-login-return',
          params: {
            providerId: this.layoutProviderId,
          }
        }).href

        this.$oauth.login({
          provider: 'line',
          clientKey: this.layoutProvider.line_login_channel_id,
          successPath: this.$route.fullPath,
          keepLogin: true,
          isDebugMode: true,
          returnUri: `${host}${href}`,
        })
      } else {
        this.$root.gaLogEvent('供應商_點擊_登入')
        const url = this.$router.resolve({name: 'provider-switch-identity'}).href
        const host = `${window.location.origin}`
        const href = this.$router.resolve({
          name: 'line-login-return',
        }).href

        this.$oauth.login({
          provider: 'line',
          clientKey: this.oauthClient.line,
          successPath: url,
          keepLogin: true,
          isDebugMode: true,
          returnUri: `${host}${href}`,
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      isLogin: 'token/isLogin',
      tokenName: 'token/name',
      avatar: "token/avatar",
      email: "token/email",
      tokenRole: "token/tokenRole",
      oauthClient: "base/oauthClient",
      layoutProvider: 'base/layoutProvider',
      layoutProviderId: 'base/layoutProviderId',
      layoutProviderName: 'base/layoutProviderName',
      currMemberRole: 'member/currMemberRole',
      memberProviders: 'member/memberProviders',
    }),
    refreshKey() {
      return this.tokenRole
    },
    providerStatus() {
      return this.$store.getters[`base/layoutProviderStatus`]
    },
    storeStatus() {
      return this.$store.getters[`store/cooperationStatus`]
    },
    hasStore() {
      return this.$store.getters[`member/hasStore`]
    },
  },
  components: {
    menuGroup: () => import('./menu/group'),
    menuLink: () => import('./menu/link'),
    memberAvatar: () => import("@/modules/member/components/memberAvatar.vue"),
  },
}
</script>

<style lang="sass" type="text/sass">
.sidebar
  .v-list-item__title
    height: 60px !important
    line-height: 60px !important
    font-size: 16px !important
  .v-list-item__content
    padding: 0 !important
</style>
